import { Dispatch } from 'redux';
import { SuSyApi } from '../../api/susyApi';
import { IAdminText } from '../../components/admin/supervisors/interfaces';
import {
    AdminTextAction,
    AdminTextActionType,
} from '../actionTypes/adminTexts';

export const createAdminText =
    (adminHelpText: IAdminText) =>
    async (dispatch: Dispatch<AdminTextAction>) => {
        const { data } = await SuSyApi.post(`/adminHelpText`, {
            adminHelpText,
        });
        dispatch({
            type: AdminTextActionType.CREATE_ADMIN_TEXT,
            payload: data,
        });
    };

export const updateAdminText =
    (adminHelpText: IAdminText) =>
    async (dispatch: Dispatch<AdminTextAction>) => {
        const { data } = await SuSyApi.put(`/adminHelpText`, {
            adminHelpText,
        });
        dispatch({
            type: AdminTextActionType.UPDATE_ADMIN_TEXT,
            payload: data,
        });
    };

export const getAllAdminTexts =
    () => async (dispatch: Dispatch<AdminTextAction>) => {
        const { data } = await SuSyApi.get(`/adminHelpText`);
        dispatch({
            type: AdminTextActionType.GET_ALL_ADMIN_TEXTS,
            payload: data,
        });
    };

export const deleteAdminText =
    (id: string | undefined) => async (dispatch: Dispatch<AdminTextAction>) => {
        const { data } = await SuSyApi.delete(`/adminHelpText/${id}`);
        dispatch({
            type: AdminTextActionType.DELETE_ADMIN_TEXT,
            payload: data,
        });
    };

export const getAllAdminTextsByRole =
    () => async (dispatch: Dispatch<AdminTextAction>) => {
        const { data } = await SuSyApi.get(`/adminHelpText/byRole`);
        dispatch({
            type: AdminTextActionType.GET_ADMIN_TEXTS_BY_ROLE,
            payload: data,
        });
    };
